import React, { useState } from 'react'
import { BiSearchAlt } from 'react-icons/bi'

const Box1 = (props) => {
  const [searchBox, setSearchBox] = useState(false)

  return (
    <div className='m-y-20' onClick={() => setSearchBox(!searchBox)}>
      <div className={`search-box-1 ${searchBox ? 'active' : 'inactive'}`}>
        <input
          placeholder={`${props.placeholder}...`}
          onChange={(e) => props.setState(e.target.value)}
        />
        <div className='icon'>
          <BiSearchAlt size={25} />
        </div>
      </div>
    </div>
  )
}
export default Box1
